import { formatDate } from '@helpers/utils'
import { ReturnsHeaderImage } from '@components/returns/ReturnsHeaderImage'
import Translations from '@helpers/translations'
import formData from '@components/returns/formData'
import { OrderData } from '@components/returns/ItemsSelection/hooks/useFetchOrderData'
import styles from './styles.module.scss'

type ReturnsFormHeaderProps = {
  orderData: Partial<OrderData>
}

function ReturnsFormHeader({ orderData }: ReturnsFormHeaderProps) {
  const itemsCount = orderData.products && !!orderData.products.length
  const itemsCountText = orderData.products
    ? `${Translations.localise('pages.returns.total-items')}: ${
        orderData.products.length
      }`
    : null

  return (
    <ReturnsHeaderImage
      classes={styles.ReturnsFormHeader}
      content={{
        ...formData.header,
        title: orderData.products
          ? `${Translations.localise('pages.returns.order-title')}: ${
              orderData.order_number || ''
            }`
          : Translations.localise('pages.returns.arrange-a-return'),
        byline: [
          !orderData.expired && orderData.max_date
            ? `${Translations.localise(
                'pages.returns.fit-promise-1'
              )} ${formatDate(orderData.max_date)} ${Translations.localise(
                'pages.returns.fit-promise-2'
              )}`
            : ''
        ]
      }}
    >
      {itemsCount && (
        <div className={styles.ReturnsFormHeader__totalItems}>
          <span>{itemsCountText}</span>
        </div>
      )}
    </ReturnsHeaderImage>
  )
}

export default ReturnsFormHeader
